import React from "react";
import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  pdf,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontFamily: "Helvetica",
  },
  header: {
    fontSize: 14,
    marginBottom: 15,
    fontWeight: "bold",
    textAlign: "center",
  },
  statusContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginBottom: 20,
  },
  statusItem: {
    width: "48%",
    marginBottom: 0,
    padding: 5,
    borderWidth: 1,
  },
  leftColumn: {
    marginRight: "4%",
  },
  statusLeft: {
    marginRight: "2%",
  },
  statusText: {
    fontSize: 10,
  },
  footer: {
    fontSize: 9,
    textAlign: "right",
    marginTop: 20,
    color: "#555555",
  },
});

// Custom component to render status items with their proper colors
const StatusItem = ({ status, count, color, index, isEven }) => {
  const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16) / 255,
          g: parseInt(result[2], 16) / 255,
          b: parseInt(result[3], 16) / 255,
        }
      : { r: 1, g: 1, b: 1 };
  };

  const bgColor = color ? hexToRgb(color) : { r: 1, g: 1, b: 1 };

  return (
    <View
      style={[
        styles.statusItem,
        index % 2 === 0 ? styles.leftColumn : {},
        {
          backgroundColor: `rgb(${bgColor.r * 100}%, ${bgColor.g * 100}%, ${
            bgColor.b * 100
          }%)`,
        },
      ]}
    >
      <Text style={styles.statusText}>
        {status} ({count})
      </Text>
    </View>
  );
};

// Main PDF Document component
const AppointmentStatusPDF = ({ siteCode, appointmentDate, statusDetails }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.header}>
          Appointment Status Count for {siteCode} in {appointmentDate}
        </Text>

        <View style={styles.statusContainer}>
          {statusDetails &&
            statusDetails.map((item, index) => (
              <StatusItem
                key={index}
                status={item.status}
                count={item.count}
                color={item.color}
                index={index}
                isEven={index % 2 === 0}
              />
            ))}
        </View>

        <Text style={styles.footer}>
          {`Printed on: ${new Date().toLocaleString()}`}
        </Text>
      </Page>
    </Document>
  );
};

// Function to generate PDF blob
export const generateAppointmentStatusPDF = async (
  siteCode,
  appointmentDate,
  statusDetails
) => {
  const pdfDoc = (
    <AppointmentStatusPDF
      siteCode={siteCode}
      appointmentDate={appointmentDate}
      statusDetails={statusDetails}
    />
  );

  const blob = await pdf(pdfDoc).toBlob();
  return blob;
};

export default AppointmentStatusPDF;
